import { useTranslations } from "contexts/LocalizationContext/hooks";
import Grid from "modules/common/components/Grid";
import PlanBox from "modules/common/components/PlanBox";
import { ChakraBox as Box, ChakraText as Text, ChakraFlex as Flex } from "@airhelp/react-ui-components";
import { PRICING_PLANS_ANCHOR, usePricingPlanDetailsConfig } from "./config";
import {
  CHOOSE_PRODUCT_ESSENTIAL_EVENT_GTM,
  CHOOSE_PRODUCT_COMPLETE_EVENT_GTM,
  CHOOSE_PRODUCT_ESSENTIAL_EVENT_MP,
  CHOOSE_PRODUCT_COMPLETE_EVENT_MP,
} from "./trackingConsts";

const AhPlusPricingPlans = () => {
  const translations = useTranslations();
  const { essential: essentialPlan, complete: completePlan } = usePricingPlanDetailsConfig();

  return (
    <Box bg="primary.900" py={{ base: 10, sm: 20 }} id={PRICING_PLANS_ANCHOR}>
      <Grid mb={0}>
        <Flex gridColumn={{ base: "span 1", md: "span 12" }} flexDir="column">
          <Flex
            flexDir={{ base: "column", md: "row" }}
            justify="center"
            align={{ base: "center", md: "stretch" }}
            pt={12}
            gap={{ base: 12, md: "initial" }}
          >
            <PlanBox
              planDetails={essentialPlan}
              events={{
                gtmEvent: CHOOSE_PRODUCT_ESSENTIAL_EVENT_GTM,
                mixpanelEvent: CHOOSE_PRODUCT_ESSENTIAL_EVENT_MP,
              }}
            />
            <PlanBox
              planDetails={completePlan}
              events={{
                gtmEvent: CHOOSE_PRODUCT_COMPLETE_EVENT_GTM,
                mixpanelEvent: CHOOSE_PRODUCT_COMPLETE_EVENT_MP,
              }}
            />
          </Flex>
          <Text px={8} color="white" fontSize="lg" textAlign="center" mt={{ base: 12, md: 16 }}>
            {translations("plan_no_matter_where_you_flying")}
          </Text>
        </Flex>
      </Grid>
    </Box>
  );
};

export default AhPlusPricingPlans;
